export const paddingBetweenPanels = 16;
export const paddingInsidePanels = 12;
export const paddingInsideElevatedPanels = 17;
